import { useStore } from "vuex";

class UsersService {
    async getToken() {
        //console.log('get token');
        const preferences = await JSON.parse(localStorage.getItem('preferences')) || {};
        if (preferences.schools && preferences.schools.length > 0) {
            const activeSchool = preferences.schools.find(school => school.isActive);
            if (activeSchool && activeSchool.users && activeSchool.users.length > 0) {
                const activeUser = activeSchool.users.find(user => user.isActive);
                if (activeUser && activeUser.auth) {
                    //console.log('token asem = ', activeUser.auth);
                    return activeUser.auth;
                }
            }
        }
        return null;
    }

    async getUser() {
        //console.log('get user');
        const preferences = await JSON.parse(localStorage.getItem('preferences')) || {};
        if (preferences.schools && preferences.schools.length > 0) {
            const activeSchool = preferences.schools.find(school => school.isActive);
            if (activeSchool && activeSchool.users && activeSchool.users.length > 0) {
                const activeUser = activeSchool.users.find(user => user.isActive);
                if (activeUser) {
                    //console.log('user asem = ', activeUser);
                    return activeUser;
                }
            }
        }
        return null;
    }

    getUserPhoto (user) {
        const store = useStore()
        if (user.photo) {
            if (user.photo.startsWith('http://') || user.photo.startsWith('https://')) {
                return user.photo;
            }
            return store.state.baseURL +  user.photo;
        }
        return 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.name) + '&background=818181&color=fff&size=48';
    }
}

export default new UsersService();